import apiClient from './client';

export interface AuditLogListItem {
  id: string;
  entityType: string;
  entityId: string;
  action: string;
  description: string;
  oldValue: string | null;
  newValue: string | null;
  actorType: 'ADMIN' | 'CLIENT' | 'SYSTEM';
  actorId: string | null;
  actorEmail: string | null;
  timestamp: string;
  ipAddress: string;
  userAgent: string | null;
}

export interface AuditLogPagedResponse {
  items: AuditLogListItem[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export interface AuditLogQueryParams {
  entityType?: string;
  entityId?: string;
  action?: string;
  search?: string;
  actorType?: string;
  fromUtc?: string;
  toUtc?: string;
  page?: number;
  pageSize?: number;
}

export const auditLogApi = {
  list: async (params: AuditLogQueryParams = {}) => {
    const query = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== null && `${v}`.trim() !== '')
    );
    const res = await apiClient.get<{ isSuccess?: boolean; data?: AuditLogPagedResponse; error?: string }>(
      '/admin/audit-log',
      { params: query }
    );
    return res.data;
  },
};
